import React, { useState, useEffect, useRef } from 'react';
import './Contact.css';
import { isMobileDevice } from '../utils/deviceUtils';
import BookDemoCard from './BookDemoCard';

const Contact = () => {
    const titleWordRefs = useRef([]);
    const isMobile = isMobileDevice();

    const hospitalityWords = [
        'Hospitality',
        'Experience',
        'Innovation',
        'Operations',
        'Automation',
        'Service',
        'Guests',
        'Efficiency',
        'Technology',
        'Connectivity',
        'Mobility',
        'Dining',
        'Security',
        'Experience',
        'Intelligence',
        'Growth',
        'Seamless',
        'Digital',
        'Workflow',
        'Solutions',
        'Experience',
        'Excellence',
        'Service',
        'Innovation',
        'Precision',
        'Comfort',
        'Efficiency',
        'Connection',
        'Progress',
        'Evolution',
        'Hospitality',
        'Technology'
    ];

    const [visibleWords, setVisibleWords] = useState([]);
    const titleWords = "Technology Built for Hospitality".split(' ');

    useEffect(() => {
        const addWord = () => {
            const word = hospitalityWords[Math.floor(Math.random() * hospitalityWords.length)];

            const section = document.querySelector('.important-text');
            let areaWidth = 600, areaHeight = 300;
            if (section) {
                areaWidth = section.offsetWidth;
                areaHeight = section.offsetHeight;
            }
            const startX = Math.random() * (areaWidth - 60);
            const startY = areaHeight - 30;
            const endX = startX;
            const endY = 0;

            const newWord = {
                word,
                category: 'hospitality',
                id: Date.now() + Math.random(),
                opacity: 0.7 + Math.random() * 0.3,
                duration: 7 + Math.random() * 5,
                delay: Math.random() * -7,
                startX,
                startY,
                endX,
                endY
            };

            setVisibleWords((prev) => {
                const updated = [...prev, newWord].slice(-14);
                return updated;
            });
        };

        const interval = setInterval(addWord, 1400);
        for (let i = 0; i < 4; i++) {
            addWord();
        }

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        const container = document.querySelector('.important-text');
        if (!container || isMobile) return;

        function handleProximityHover(e) {
            titleWordRefs.current.forEach((el) => {
                if (!el) return;
                const rect = el.getBoundingClientRect();
                const mx = e.clientX;
                const my = e.clientY;
                const closestX = Math.max(rect.left, Math.min(mx, rect.right));
                const closestY = Math.max(rect.top, Math.min(my, rect.bottom));
                const dx = mx - closestX;
                const dy = my - closestY;
                const distance = Math.sqrt(dx * dx + dy * dy);
                if (distance < 80) {
                    el.classList.add('force-hover');
                    el.style.setProperty('--cursor-x', `${mx - rect.left}px`);
                    el.style.setProperty('--cursor-y', `${my - rect.top}px`);
                } else {
                    el.classList.remove('force-hover');
                }
            });
        }

        function clearProximityHover() {
            titleWordRefs.current.forEach((el) => {
                if (el) el.classList.remove('force-hover');
            });
        }

        container.addEventListener('mousemove', handleProximityHover);
        container.addEventListener('mouseleave', clearProximityHover);
        return () => {
            container.removeEventListener('mousemove', handleProximityHover);
            container.removeEventListener('mouseleave', clearProximityHover);
        };
    }, [isMobile]);

    const handleWordInteraction = (e, index) => {
        if (isMobile) return;
        
        const span = titleWordRefs.current[index];
        if (span) {
            const rect = span.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            span.style.setProperty('--cursor-x', `${x}px`);
            span.style.setProperty('--cursor-y', `${y}px`);
        }
    };

    const handleWordLeave = (index) => {
        if (isMobile) return;
        
        const span = titleWordRefs.current[index];
        if (span) {
            span.style.setProperty('--cursor-x', '50%');
            span.style.setProperty('--cursor-y', '50%');
        }
    };

    return (
        <section id="contact" className="contact">
            <div className="section-header">
                <h2 data-text="Let’s Build the Future of Hospitality">Let’s Build the Future of Hospitality</h2>
            </div>
            <div 
                className="important-text"
                onMouseEnter={() => !isMobile && document.body.classList.add('cursor-large')}
                onMouseLeave={() => !isMobile && document.body.classList.remove('cursor-large')}
            >
                <div className="title-words">
                    {titleWords.map((word, index) => (
                        <span
                            key={index}
                            className="title-word"
                            ref={el => (titleWordRefs.current[index] = el)}
                            onMouseMove={e => handleWordInteraction(e, index)}
                            onMouseLeave={() => handleWordLeave(index)}
                        >
                            {word}
                        </span>
                    ))}
                </div>
                <div className="animated-words">
                    {visibleWords.map(({ word, id, category, opacity, duration, delay, startX, startY, endX, endY }) => (
                        <span
                            key={id}
                            className="animated-word"
                            style={{
                                opacity,
                                animationDuration: `${duration}s`,
                                animationDelay: `${delay}s`,
                                '--start-x': `${startX}px`,
                                '--start-y': `${startY}px`,
                                '--end-x': `${endX}px`,
                                '--end-y': `${endY}px`,
                            }}
                            data-category={category}
                        >
                            {word}
                        </span>
                    ))}
                </div>
            </div>
            <BookDemoCard />
        </section>
    );
};

export default Contact;